import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-prettify',
	templateUrl:'./PrettifyPluginPage.html',
	styles: [],
	styleUrls:['./PrettifyPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class PrettifyPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_634 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>prettify</artifactId>
</dependency>
\`\`\``;
	mdContent_635 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:prettify:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_636 = `\`\`\`json
"code-prettify": "^0.1.0"
\`\`\``;
	mdContent_637 = `\`\`\`java
Prettify&lt;?&gt; codeBlock = new Prettify&lt;&gt;();
codeBlock.setSourceCodeLanguage(SourceCodeLanguages.Java);
codeBlock.setTheme(SourceCodePrettifyThemes.Sons_Of_Obsidian);
codeBlock.setShowLineNums(true);
codeBlock.setText("public class HelloWorld {\\n    public static void main(String[] args) {\\n    }\\n}");
\`\`\``;
	mdContent_638 = `\`\`\`java
Prettify&lt;?&gt; sql = new Prettify&lt;&gt;();
sql.setSourceCodeLanguage(SourceCodeLanguages.Sql);
sql.setText("SELECT u.name, COUNT(*) FROM users u GROUP BY u.name;");
\`\`\``;
	mdContent_639 = `\`\`\`java
Prettify<?> codeBlock = new Prettify<>();
codeBlock.setSourceCodeLanguage(SourceCodeLanguages.Java);
codeBlock.setShowLineNums(true);
codeBlock.setTheme(SourceCodePrettifyThemes.Sons_Of_Obsidian);
codeBlock.setText("public class HelloWorld { }");
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
